import { useQuery } from 'common/hooks';
import { getCategoryEligibilityApi } from '../objectives.service';

type CategoryEligibility = {
  canCreateOrganizationObjective: boolean;
  canCreateTeamObjective: boolean;
};

export const useGetCategoryEligibility = () => {
  const queryResponse = useQuery(
    ['objective-category-eligibility'],
    getCategoryEligibilityApi,
    {
      select: (response) => ({
        ...response,
        data: response.data as CategoryEligibility,
      }),
    },
  );

  return {
    ...queryResponse,
    data: queryResponse?.data?.data,
  };
};
